
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import LogoHeader from '../Assets/Images/SumanikservicesLogo.png';
import '../Assets/Css/webheader.css';

import { MdMarkEmailRead, MdLocationOn } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";

function WebHeader() {
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);

    const handleNavClick = () => setExpanded(false);

    return (
        <>
            {/* Top Contact Navbar */}
            <div className="top-header">
                <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <div className="contact-info mb-2 mb-md-0">
                        <MdLocationOn /> <span>Wanwadi Pune-411040</span>
                        <span className='mx-2'>|</span>
                        <a
                            href="https://wa.me/7798737751"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white"
                        >
                            <FaPhoneSquareAlt /> 7798737751
                        </a>
                    </div>
                    <div className="email-info">
                        <a
                            href="mailto:contact@sumanikservices.com"
                            className="text-white d-flex align-items-center gap-2"
                        >
                            <MdMarkEmailRead />
                            contact@sumanikservices.com
                        </a>
                    </div>
                </Container>
            </div>

            {/* Main Navbar */}
            <Navbar expand="lg" className="custom-navbar" expanded={expanded}>
                <Container>
                    <Navbar.Brand as={NavLink} to="/">
                        <img src={LogoHeader} alt="Logo" className="navbar-logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mx-auto">
                            <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>About Us</Nav.Link>
                            <Nav.Link as={NavLink} to="/services" onClick={handleNavClick}>Our Services</Nav.Link>
                            <Nav.Link as={NavLink} to="/gallery" onClick={handleNavClick}>Gallery</Nav.Link>
                            <Nav.Link as={NavLink} to="/newsandevents" onClick={handleNavClick}>News & Events</Nav.Link>
                            <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick}>Contact Us</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default WebHeader;
